module.exports = __webpack_public_path__ + "static/media/24UHCHR26.b9277aaf.jpg";